<script>
  import { activeSectionId } from './scrollspy.store';

  export let section;

  $: active = $activeSectionId === section;
</script>

<span {...$$props} class:active>
  <slot />
</span>
